import { int } from "@goodgamestudios/math-utilities";

import { BasicComboboxEvent } from "../event/BasicComboboxEvent";

import DisplayObject = createjs.DisplayObject;
import Container = createjs.Container;
import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;
import TextField = createjs.TextField;

export class BasicComboboxComponent {
    protected CLOSED_HEIGHT: number = 0;
    protected ITEM_HEIGHT: number = 0;
    protected ITEM_WIDTH: number = 0;
    protected static ITEM_SPACE: number = 0;

    protected _disp: MovieClip;
    protected _defaultString: string;

    protected _itemData: any[];
    protected _selectedItem: number = 0;

    protected _scaleOpen: number = NaN;

    protected _itemDir: number = 0;

    private _itemClass: any;

    constructor(disp: MovieClip, _itemClass: any, defaultString: string = "", itemDir: number = 1, closedHeight: number = 30, itemHeight: number = 28, itemWidth: number = 0, changeArrow: boolean = false) {
        this._disp = disp;
        this._itemClass = _itemClass;
        this._itemDir = itemDir;
        this.CLOSED_HEIGHT = closedHeight;
        this.ITEM_HEIGHT = itemHeight;
        this.ITEM_WIDTH = itemWidth;

        this._disp.addEventListener(MouseEvent.MOUSE_UP, this.bindFunction(this.onMouseUp));
        this._disp.addEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOver));
        this._disp.addEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOut));
        this._itemData = [];
        this._defaultString = defaultString;

        this._disp.item_Holder.visible = false;

        this._disp.btn_arrow.gotoAndStop(2);

        if (changeArrow)
            this._disp.btn_arrow.x = this.ITEM_WIDTH - 20;

        if (this.ITEM_WIDTH > 0)
            this._disp.bg.width = this.ITEM_WIDTH;

        this._disp.bg.gotoAndStop(1);
        this._disp.bg.scaleY = 1;
        this._disp.bg.mouseChildren = false;
        this._disp.txt_selected.mouseEnabled = false;
        if (this._defaultString != "")
            this._disp.txt_selected.text = this._defaultString;

    }

    protected get itemClass(): any {
        return this._itemClass;
    }

    protected fillItems(): void {
        while (this._disp.item_Holder.numChildren > 0)
            this._disp.item_Holder.removeChildAt(0);

        if (this._itemData.length > 1) {
            var heightOpen: number = int(this.CLOSED_HEIGHT + this._itemData.length * (this.ITEM_HEIGHT + BasicComboboxComponent.ITEM_SPACE) + 15);
            this._scaleOpen = heightOpen / this.CLOSED_HEIGHT;

            for (var i: number = 0; i < this._itemData.length; i++) {
                var item: MovieClip = new this.itemClass();
                item.mouseChildren = false;
                item.txt_item.text = this._itemData[i].label;
                item.bg.width = this.ITEM_WIDTH;
                item.bg.gotoAndStop(1);
                item.id = i;
                this._disp.item_Holder.addChild(item);
                item.y = i * (this.ITEM_HEIGHT + BasicComboboxComponent.ITEM_SPACE) * this._itemDir;
            }
        }
        this._disp.item_Holder.visible = false;
        this.updateAllTextFields();
    }

    public updateAllTextFields(specificMc: Container = null): void {
        var container: Container = (specificMc ? specificMc : this.disp as Container);

        for (var textField of this.findTextFields(container))
            this.updateTextField(textField);
    }

    /**
     * Search recursively for textfields
     */
    protected findTextFields(container: Container): any[] {
        var result: any[] = [];

        for (var i: number = 0; i < container.numChildren; i++) {
            var disp: DisplayObject = container.getChildAt(i);

            if (disp instanceof TextField)
                result.push(disp);
            else if (disp instanceof Container) {
                var childResult: any[] = this.findTextFields(disp as Container);
                result = result.concat(childResult);
            }
        }
        return result;
    }

    protected updateTextField(textField: TextField): void {
    }

    public addItem(data: any): void {
        this._itemData.push(data);
        //fillItems();
        var heightOpen: number = int(this.CLOSED_HEIGHT + this._itemData.length * (this.ITEM_HEIGHT + BasicComboboxComponent.ITEM_SPACE));
        if (this._itemDir == 1) {
            //	heightOpen += CLOSED_HEIGHT/2;
            heightOpen += int((this._disp.item_Holder.y - (this._disp.txt_selected.y + this._disp.txt_selected.height)));
        }
        this._scaleOpen = heightOpen / this.CLOSED_HEIGHT;

        var item: MovieClip = new this.itemClass();
        item.mouseChildren = false;
        item.txt_item.text = data.label;
        if (this.ITEM_WIDTH > 0)
            item.bg.width = this.ITEM_WIDTH;
        item.bg.gotoAndStop(1);
        item.id = this._itemData.length - 1;
        item.y = ((this._itemData.length - 1) * (this.ITEM_HEIGHT + BasicComboboxComponent.ITEM_SPACE)) * this._itemDir;
        this._disp.item_Holder.addChild(item);
        this.updateAllTextFields();
    }

    public selectItemIndex(index: number): void {
        if (this._itemData.length < 1)
            return;
        if (index > this._itemData.length || index < 0) {
            this._selectedItem = -1;
            this._disp.txt_selected.text = this._defaultString;
        }
        else {
            this._selectedItem = index;
            this._disp.txt_selected.text = this._itemData[this._selectedItem].label;
        }
        this._disp.dispatchEvent(new BasicComboboxEvent(BasicComboboxEvent.COMBOBOXCHANGE));
    }

    protected showItems(): void {
        this._disp.btn_arrow.gotoAndStop(1);
        this._disp.bg.scaleY = this._scaleOpen;
        if (this._itemDir == -1) {
            this._disp.bg.y = -this._disp.bg.height + this.CLOSED_HEIGHT;
            this._disp.item_Holder.y = -this.CLOSED_HEIGHT;
        }
        this._disp.item_Holder.visible = true;
        this._disp.dispatchEvent(new BasicComboboxEvent(BasicComboboxEvent.COMBOBOXSELECT, 1));
        //updateAllTextFields();
    }

    public hideItems(): void {
        this._disp.btn_arrow.gotoAndStop(2);
        this._disp.bg.scaleY = 1;
        this._disp.bg.y = 0;
        this._disp.item_Holder.visible = false;
        this._disp.dispatchEvent(new BasicComboboxEvent(BasicComboboxEvent.COMBOBOXSELECT, 0));
    }

    protected onMouseUp(event: MouseEvent): void {
        switch (event.target) {
            case this._disp.bg:
            case this._disp.btn_arrow:
                if (!this._disp.btn_arrow.enabled) return;
                this.onClickArrow();
                break;
        }
        if (event.target instanceof this.itemClass) {
            this.selectItemIndex(event.target.id);
            this.hideItems();

        }
    }

    protected onMouseOut(event: MouseEvent): void {
        //			BasicLayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
        if (event.target instanceof this.itemClass) {
            event.target.bg.gotoAndStop(1);
        }
    }

    protected onMouseOver(event: MouseEvent): void {
        //			BasicLayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
        if (event.target instanceof this.itemClass) {
            event.target.bg.gotoAndStop(2);
        }
    }

    public clearItems(): void {
        this.hideItems();
        this._itemData = [];
        this.fillItems();
    }

    protected onClickArrow(): void {
        if (this._disp.bg.scaleY > 1)
            this.hideItems();
        else
            this.showItems();
    }

    public get selectedId(): number {
        if (this._selectedItem != -1)
            return this._selectedItem;
        else
            return -1;
    }

    public get selectedData(): any {
        if (this._selectedItem == -1)
            return null;
        else
            return this._itemData[this._selectedItem].data;
    }

    public get selectedLabel(): string {
        if (this._selectedItem == -1)
            return "";
        else
            return this._itemData[this._selectedItem].label;
    }

    public get disp(): MovieClip {
        return this._disp;
    }

    public get itemData(): any[] {
        return this._itemData;
    }
}
